import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from '../../utils/compose';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import './AdminSignIn.css';

const ADMIN_EMAIL = 'jeethbuildcon@gmail.com';

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
  loading: false,
};

class AdminSignInFormBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    event.preventDefault();
    const { email, password } = this.state;

    // Check if email is admin email
    if (email !== ADMIN_EMAIL) {
      this.setState({
        error: { message: 'Unauthorized: Only platform administrator can access this panel.' },
      });
      return;
    }

    this.setState({ loading: true });

    if (typeof window !== 'undefined') {
      window.localStorage.removeItem('lastLoginAt');
    }

    this.props.firebase
      .doSignInWithEmailAndPassword(email, password)
      .then(() => {
        if (typeof window !== 'undefined') {
          window.localStorage.setItem('lastLoginAt', String(Date.now()));
        }
        this.setState({ ...INITIAL_STATE });
        this.props.history.push(ROUTES.ADMIN_PANEL);
      })
      .catch(error => {
        this.setState({ error, loading: false });
      });
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, password, error, loading } = this.state;
    const isInvalid = password === '' || email === '';

    return (
      <div className="admin-signin-container">
        <div className="admin-signin-card">
          <div className="admin-signin-header">
            <div className="admin-logo">
              <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h1>Platform Admin</h1>
            <p>Douglas & McCartney</p>
          </div>

          <form onSubmit={this.onSubmit} className="admin-signin-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                id="email"
                name="email"
                value={email}
                onChange={this.onChange}
                type="email"
                placeholder="jeethbuildcon@gmail.com"
                required
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                name="password"
                value={password}
                onChange={this.onChange}
                type="password"
                placeholder="Enter your password"
                required
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="error-message">
                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>{error.message}</span>
              </div>
            )}

            <button
              type="submit"
              disabled={isInvalid || loading}
              className="admin-signin-button"
            >
              {loading ? (
                <>
                  <div className="spinner"></div>
                  <span>Signing In...</span>
                </>
              ) : (
                <>
                  <span>Sign In</span>
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                  </svg>
                </>
              )}
            </button>
          </form>

          <div className="admin-signin-footer">
            <p>Restricted Access Only</p>
            <p>© {new Date().getFullYear()} Douglas & McCartney</p>
          </div>
        </div>
      </div>
    );
  }
}

const AdminSignInForm = compose(
  withRouter,
  withFirebase,
)(AdminSignInFormBase);

export default AdminSignInForm;
export { AdminSignInForm };

